<template>
  <v-container
    fluid
    grid-list-md
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <v-layout row wrap>
      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="perm_data_setting"
        :value="$t('components.plancreationwizard.general_settings')"
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'planGeneralParameters',
                  params: { planId: selectedPlan.Id, edit: true },
                })
              "
            >
              {{ $t("views.dashboard.view") }}
            </v-btn>
            <!-- <v-btn
              text
              color="primary"
              @click="$router.push({name: 'planRenewWizard'})"
            >{{$t('views.planparameters.renew')}}</v-btn> -->
          </div>
        </template>
      </material-stats-card>

      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="business"
        :value="$t('views.planparameters.trust_fund')"
        v-if="
          (planIdentity.PlanType === 'HW' ||
            planIdentity.PlanType === 'Pension') &&
            planIdentity.TrustFund &&
            role.indexOf('Broker Plan Manager') > -1
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'trustFund',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("components.vuematerialdashboard.core.drawer.view_edit") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>

      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="home_work"
        :value="$t('globals.insurance_carriers')"
        v-if="
          planIdentity.PlanType === 'HW' &&
            planOptions.HasPremiums &&
            role.indexOf('Broker Plan Manager') > -1
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'insuranceCarriers',
                  params: { planId: selectedPlan.Id, edit: true },
                })
              "
            >
              {{ $t("components.vuematerialdashboard.core.drawer.view_edit") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>

      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="policy"
        :value="$t('globals.coverage')"
        v-if="
          (planIdentity.PlanType === 'HW' ||
            planIdentity.PlanType === 'Pension') &&
            role.indexOf('Broker Plan Manager') > -1
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'coverage',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("components.vuematerialdashboard.core.drawer.view_edit") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>

      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="mdi-lan"
        :value="$t('views.unionlocals.union_locals')"
        v-if="planIdentity.PlanType === 'Pension'"
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'unionLocals',
                  params: { planId: selectedPlan.Id, edit: true },
                })
              "
            >
              {{ $t("components.vuematerialdashboard.core.drawer.view_edit") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
    </v-layout>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { planSetter } from "../mixins/planSetter";
export default {
  data() {
    return {
      commissionsCount: 3,
    };
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("plansMembers", ["planOptions", "planIdentity"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
  },
};
</script>

<style>
.with-margin {
  margin: 10px !important;
}
</style>
